import ajax from '../../lib/ajax'
export async function GetIndexUpData(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetIndexUpData',{params:payload},true)
    return res.data.result
}
export async function GetTenantInfo(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetTenantInfo',{params:payload},false)
    return res.data.result
}
export async function GetSelectListByTenantId(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetSelectListByTenantId',{params:payload},false)
    return res.data.result
}
export async function PatientListByMachineData(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/PatientListByMachineData',payload,true)
    return res.data.result
}
export async function PatientInMachineData(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/PatientInMachineData',payload,true)
    return res.data.result
}
